import moment from 'moment';

export const TIME_PERIOD = ['Month', 'Week', 'Day'];

export const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const MONTH_DAYS = Array.from({ length: 30 }, (_, i) => {
  const day = i + 1;

  return {
    value: day,
    label: moment().set('date', day).format('Do'),
  };
});
